import { EgretLoadable } from "egret";
import { authRoles } from "../../auth/authRoles";

const Contact = EgretLoadable({
  loader: () => import("./Contact")
});

const ContactProfileView = EgretLoadable({
  loader: () => import("./ContactProfileView")
});

const ContactForm = EgretLoadable({
  loader: () => import("./ContactForm")
});

const contactRoutes = [
    {
        path: "/contacts",
        component: Contact,
        auth: authRoles.merchant
    },
    {
      path: "/contact-add",
      component: ContactForm,
      auth: authRoles.merchant
    },
    {
        path: "/contact/:id",
        component: ContactProfileView,
        auth: authRoles.merchant
    }
];

export default contactRoutes;
